export const isAdmin = (user) => {
  if (!user) {
    return false;
  }

  if (typeof user.role === 'string') {
    return user.role.toLowerCase() === 'admin';
  }

  if (Array.isArray(user.permissions)) {
    return user.permissions.includes('admin:access');
  }

  return false;
};

export const hasPermission = (user, permission) => {
  if (!user || !permission) {
    return false;
  }

  if (Array.isArray(user.permissions)) {
    return user.permissions.includes(permission);
  }

  return false;
};

export const getUserRole = (user) => {
  if (!user) {
    return 'user';
  }

  return isAdmin(user) ? 'admin' : user.role || 'user';
};
